export const websiteBuilder = {
  seo: {
    title: "Weboldal — Bespire AI asszisztens",
    description:
      "Foglalható, mobilbarát weboldal, amit a Bespire AI épít és tart karban. Nem külön termék — a napi asszisztensed egyik képessége.",
  },
  hero: {
    badge: "Weboldal",
    title: "Weboldal, amit chatben építesz, chatben módosítasz",
    subtitle:
      "Nem sablonválasztás, nem 3 hetes projekt. Elmondod, mit csinálsz — a Bespire AI kész oldalt hoz létre: foglalás, szolgáltatások, árak, SEO és mobilnézet. Bármit átírsz egy mondattal.",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaPricing: "Nézd meg az árakat →",
    sitePreview: {
      label: "Weboldal-előnézet · illusztráció",
      urlBar: "bella-studio.bespire.io",
      businessName: "Bella Studio",
      tagline: "Kismama jóga, ami tényleg megnyugtat.",
      navItems: ["Órák", "Rólam", "Foglalás", "Kapcsolat"],
      heroCta: "Foglalj időpontot",
      infoCards: [
        { label: "Következő óra", value: "Csütörtök 18:00" },
        { label: "Szabad hely", value: "3 / 8" },
      ],
      trustLine: "Új: A/B tesztelt szöveg · SEO kész · Mobilbarát",
    },
  },
  process: {
    title: "Három lépés a kész oldalig",
    subtitle:
      "Ugyanaz a rendszer, ami minden más területen segít — most a weboldaladat is felépíti és karban tartja.",
    steps: [
      {
        step: "01",
        icon: "MessageCircle",
        title: "Mondd el, mit csinálsz",
        description:
          "Egy chat-beszélgetés. Nincs sablonválasztás, nincs designer-briefing — a Bespire végigkérdez, és a válaszaidból dolgozik.",
        bullets: [
          "5–10 perc rövid chat",
          "Meglévő oldalról is át tud emelni tartalmat",
          "A márkakártyád adja a stílust automatikusan",
        ],
      },
      {
        step: "02",
        icon: "Wand2",
        title: "Kész oldalt kapsz",
        description:
          "Nem drótvázat — élő oldalt, foglalással, szövegekkel, SEO-alapokkal, mobilnézettel. Élesíthető aznap.",
        bullets: [
          "Foglalás, szolgáltatások, árak, GYIK, kapcsolat",
          "SEO alapok, meta címek, sitemap, canonical",
          "Mobil és tablet nézet automatikusan",
        ],
      },
      {
        step: "03",
        icon: "Sparkles",
        title: "Egy mondattal módosítasz",
        description:
          "\"Írj át egy melegebb hangvételre.\" \"Cseréld a képet.\" \"Emeld ki a hétvégi csomagot.\" A Bespire elvégzi, te jóváhagyod.",
        bullets: [
          "Nincs többé fejlesztő, nincs jegy, nincs várakozás",
          "Verziók: bármikor visszavonható",
          "Saját domain vagy ingyen aldomain",
        ],
      },
    ],
  },
  beforeAfter: {
    title: "Előtte–utána: ugyanaz a vállalkozás",
    subtitle:
      "Nem szebb weboldal a szebbség kedvéért. Egy oldal, ami a napi munkádba kapcsolódik.",
    before: {
      label: "Előtte",
      businessName: "Sablon-weboldal",
      tagline: "3 hónapja élesítve, azóta nem nyúltunk hozzá.",
      bio: "Egy fejlesztő fél éve összerakta. Foglalás külön eszközben. Módosítás jegy, várakozás, extra díj. SEO-t senki nem karbantart.",
      problems: [
        "Foglalás külön rendszerben — ügyfélnek 2 kattintás",
        "Módosításhoz fejlesztő kell",
        "SEO és szövegek nem frissülnek",
        "Nincs adat arról, mi működik és mi nem",
      ],
    },
    after: {
      label: "Utána",
      businessName: "Ügyfél-oldal a Bespire-ből",
      tagline: "Egy rendszer: oldal, foglalás, tartalom, mérés.",
      bio: "A weboldal, a foglalás, az árazás és a szövegek egy helyről mennek. A Bespire AI látja, mit néznek meg, mit foglalnak — és javaslatot ad.",
      wins: [
        "Foglalás közvetlenül az oldalon, egy kattintás",
        "Chatben átírsz bármit, aznap élesítve",
        "SEO alapok automatikusan karban",
        "Adat-vezérelt javaslatok — mit érdemes kiemelni",
      ],
    },
  },
  showcase: {
    title: "Egy prompt, több stílus — te választasz",
    subtitle:
      "Ugyanaz a vállalkozás, több irány. A Bespire élőben generál teljes oldal-variánsokat, nem csak paletta-mintát.",
    styles: [
      {
        name: "Nyugodt studio",
        heading: "Playfair",
        body: "Manrope",
        tone: "Meleg · Csendes · Prémium",
        palette: ["#F5B5C6", "#B8CBB5", "#EFE3D0", "#2B2530"],
        pages: "Kezdőlap · Órák · Csomagok · Rólam · Foglalás",
      },
      {
        name: "Modern klinika",
        heading: "Inter",
        body: "Inter",
        tone: "Tiszta · Szakértő · Megbízható",
        palette: ["#0EA5E9", "#F1F5F9", "#0F172A", "#22D3EE"],
        pages: "Kezdőlap · Szolgáltatások · Csapat · Foglalás · Blog",
      },
      {
        name: "Energikus fitnesz",
        heading: "Space Grotesk",
        body: "Manrope",
        tone: "Bátor · Direkt · Motiváló",
        palette: ["#F97316", "#111827", "#F3F4F6", "#FDBA74"],
        pages: "Kezdőlap · Programok · Edzők · Bérletek · Foglalás",
      },
      {
        name: "Természetes bio",
        heading: "Fraunces",
        body: "Nunito",
        tone: "Őszinte · Meleg · Kézműves",
        palette: ["#65A30D", "#F5F5DC", "#3F3F46", "#FDE68A"],
        pages: "Kezdőlap · Kezelések · Rólam · Vélemények · Foglalás",
      },
      {
        name: "Kreatív műhely",
        heading: "Recoleta",
        body: "Manrope",
        tone: "Játékos · Merész · Egyedi",
        palette: ["#8B5CF6", "#F472B6", "#FEF3C7", "#1F2937"],
        pages: "Kezdőlap · Workshopok · Portfólió · Rólam · Foglalás",
      },
      {
        name: "Elegáns coaching",
        heading: "Cormorant",
        body: "Inter",
        tone: "Csendes · Igényes · Bizalmi",
        palette: ["#334155", "#E2E8F0", "#C7A17A", "#0F172A"],
        pages: "Kezdőlap · Programok · Módszer · Esettanulmányok · Foglalás",
      },
    ],
    included: {
      title: "Ami minden variánsban benne van",
      items: [
        "Foglalási rendszer az oldalon",
        "Mobil és tablet nézet",
        "SEO alapok, meta címek, sitemap",
        "GDPR-kompatibilis, EU szerver",
        "Saját domain vagy ingyen aldomain",
        "Chat-alapú szerkesztés, verziók",
      ],
    },
  },
  chat: {
    title: "Kérj módosítást úgy, mintha egy webesnek szólnál",
    subtitle:
      "Csak nem jegyet nyitsz és nem holnaputánra kapod meg — hanem most, az előfizetésed része.",
    chat: {
      title: "Weboldal asszisztens",
      online: "Online",
      messages: [
        { role: "user" as const, content: "Túl hideg az oldalam, melegebb hangvételt szeretnék és nagyobb foglaló gombot." },
        { role: "assistant" as const, content: "Rendben. Nézzük, mit változtatok:", list: [
          "🎨 Szín-hangolás: több meleg tónus a főoldalon",
          "✍️ Szöveg: barátságosabb hangvétel, \"te\" megszólítás",
          "📅 CTA: nagyobb, ragadósan görgő foglaló gomb",
        ] },
        { role: "user" as const, content: "Jó. És rakj ki egy szekciót a hétvégi csomagról." },
        { role: "assistant" as const, content: "Kész: új szekció a hero alá, 3 hétvégi csomag képpel, árral, foglaló gombbal. Előnézet? 🚀" },
        { role: "user" as const, content: "Előnézet." },
        { role: "assistant" as const, content: "Előnézeti linket küldtem. Ha jóváhagyod, 1 percen belül élesítem." },
      ],
    },
  },
  liveExamples: {
    eyebrow: "Élő példák",
    title: "Nézd meg valódi ügyfeleink oldalait",
    subtitle: "Mind a Bespire-ben készült, néhány óra alatt — kattints és nézd meg élesben.",
    ctaLabel: "Oldal megnyitása →",
    items: [
      { name: "Bespire nyitóoldal", tag: "SaaS", href: "/landing4" },
      { name: "TSMT partner oldal", tag: "Egészségügy", href: "/tsmt-partner" },
      { name: "Vállalkozói szolgáltatás", tag: "Építőipar", href: "/contractors" },
    ],
  },
  crossLinks: {
    title: "A weboldal önmagában kevés",
    subtitle: "A Bespire ugyanezt az arculatot és tartalmat viszi tovább a foglalásba, marketingbe, ügyfélkapcsolatba és a napi ritmusodba.",
  },
  cta: {
    title: "Építsd meg az oldaladat még ma",
    subtitle: "3 nap ingyenes próba, kártya nélkül.",
    primary: "Próbáld ki 3 napig ingyen",
    secondary: "Árak megnézése",
  },
};
